import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import React, { useImperativeHandle, useState } from 'react';
import CalendarDay from '@app/state/calendar/CalendarDay';
import Utilities from '@util/Utilities';
import ModalHandler from '@app/component/overlays/modal/ModalHandler';
import useModal from '@app/component/overlays/modal/ModalRef';
import Modal from '@app/component/overlays/modal/Modal';
import Loader from '@app/component/loader/Loader';
import MarketSateDayPriceEvolutionGraphs
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_calendar/_desktop/fragment/timeline/MarketSateDayPriceEvolutionGraphs';


const MarketStateDayPriceEvolutionModal: React.FunctionComponent<{
	calendarDay: CalendarDay;
	ref: any
}> = React.forwardRef(({ calendarDay }, ref: React.Ref<Omit<ModalHandler, 'getModalHtmlElement'>>) => {
	const modal = useModal();
    const { companyHotel } = useSelectedCompanyHotel();
	const [isOpen, setIsOpen] = React.useState(false);
	const [tab, setTab] = useState<'ANALYTICAL' | 'MEDIAN'>('MEDIAN');

	useImperativeHandle(ref, () => {
		return {
			open: () => {
				modal.open();
				setTab('MEDIAN');
				setIsOpen(true);
			},
			close: () => {
				modal.close();
				setIsOpen(false);
				setTab('MEDIAN');
			},
			isOpen: modal.isOpen,
		};
	});

	return <Modal ref={modal.ref} title={Utilities.formatDate(calendarDay.date, 'DD MMMM YYYY')} width="full">
		{modal && isOpen ? <>
			<div className="border-b border-gray-200 mb-4">
				<nav className="-mb-px flex" aria-label="Tabs">
					<a
						className={`whitespace-nowrap border-b-2 px-3 py-1.5 text-sm font-medium cursor-pointer ${tab === 'MEDIAN' ? 'border-blue-500 text-blue-600' : 'text-gray-500 hover:border-gray-300 hover:text-gray-700  border-transparent'}`}
						onClick={() => setTab('MEDIAN')}>
						{companyHotel.comparisonLabel()}
					</a>
					<a
						className={`whitespace-nowrap border-b-2 px-3 py-1.5 text-sm font-medium cursor-pointer ${tab === 'ANALYTICAL' ? 'border-blue-500 text-blue-600' : 'text-gray-500 hover:border-gray-300 hover:text-gray-700  border-transparent'}`}
						onClick={() => setTab('ANALYTICAL')}>
						Analytical
					</a>
				</nav>
			</div>
			<MarketSateDayPriceEvolutionGraphs calendarDay={calendarDay} tab={tab} />
		</> : <Loader />}
	</Modal>;

});


export default MarketStateDayPriceEvolutionModal;